// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/precipitation-type-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/precipitation-type-definitions/precipitation-type-definitions.js';

mount([g0]);
